/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./wx-icon.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/common";
import * as i3 from "@angular/material/tooltip";
import * as i4 from "@angular/cdk/overlay";
import * as i5 from "@angular/cdk/scrolling";
import * as i6 from "@angular/cdk/platform";
import * as i7 from "@angular/cdk/a11y";
import * as i8 from "@angular/cdk/bidi";
import * as i9 from "./wx-icon.component";
var styles_WxIconComponent = [i0.styles];
var RenderType_WxIconComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_WxIconComponent, data: {} });
export { RenderType_WxIconComponent as RenderType_WxIconComponent };
export function View_WxIconComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 16777216, null, null, 2, "div", [["class", "wx-icon"]], null, [[null, "longpress"], [null, "keydown"], [null, "touchend"]], function (_v, en, $event) { var ad = true; if (("longpress" === en)) {
        var pd_0 = (i1.ɵnov(_v, 2).show() !== false);
        ad = (pd_0 && ad);
    } if (("keydown" === en)) {
        var pd_1 = (i1.ɵnov(_v, 2)._handleKeydown($event) !== false);
        ad = (pd_1 && ad);
    } if (("touchend" === en)) {
        var pd_2 = (i1.ɵnov(_v, 2)._handleTouchend() !== false);
        ad = (pd_2 && ad);
    } return ad; }, null, null)), i1.ɵdid(1, 278528, null, 0, i2.NgClass, [i1.IterableDiffers, i1.KeyValueDiffers, i1.ElementRef, i1.Renderer2], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), i1.ɵdid(2, 147456, null, 0, i3.MatTooltip, [i4.Overlay, i1.ElementRef, i5.ScrollDispatcher, i1.ViewContainerRef, i1.NgZone, i6.Platform, i7.AriaDescriber, i7.FocusMonitor, i3.MAT_TOOLTIP_SCROLL_STRATEGY, [2, i8.Directionality], [2, i3.MAT_TOOLTIP_DEFAULT_OPTIONS]], { message: [0, "message"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "wx-icon"; var currVal_1 = _co.cssClass; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_2 = _co.tooltip; _ck(_v, 2, 0, currVal_2); }, null); }
export function View_WxIconComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-wx-icon", [], null, null, null, View_WxIconComponent_0, RenderType_WxIconComponent)), i1.ɵdid(1, 49152, null, 0, i9.WxIconComponent, [], null, null)], null, null); }
var WxIconComponentNgFactory = i1.ɵccf("app-wx-icon", i9.WxIconComponent, View_WxIconComponent_Host_0, { flightCategory: "flightCategory" }, {}, []);
export { WxIconComponentNgFactory as WxIconComponentNgFactory };
